import 'choerodon-ui/lib/style/index.less';
import './index.less';
// style dependencies
import '../../button/style';
import '../../modal-provider/style';
